// Créer ou modifier un événement.
//
// Comme les autres fenêtres modales, elle reste en HTML : elle s'ouvre, se
// remplit, se ferme, et n'a pas d'état qui vive dans le temps.
//
// Le champ de date est un `datetime-local` : un culte a une heure, pas seulement
// un jour. C'est aussi ce qui permet de dire « demain à 9 h » plutôt que
// « 09/08/2026 » — la date brute ne parle à personne.

import Store from "../store.js";
import { esc, toast, modale } from "../ui.js";

/** Un `datetime-local` veut « 2026-08-09T09:00 », dans l'heure LOCALE. */
const pourChamp = (ts) => {
  const d = new Date(ts || Date.now() + 36e5);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

/**
 * @param {object} [existant]  l'événement à modifier, ou rien pour en créer un
 * @param {object} [rattachement]  { pageId, pageNom } ou { groupeId, groupeNom }
 * @param {Function} [apres]  reçoit l'identifiant
 */
export function editerEvenement(ctx, existant, rattachement = {}, apres) {
  const e = existant || {};
  const { el } = modale({
    titre: existant ? "Modifier l'événement" : "Créer un événement",
    corps: `
      <label class="label">Titre
        <input class="champ" id="ev-titre" maxlength="100" value="${esc(e.titre || "")}"
               placeholder="Ex : Culte de reconnaissance">
      </label>
      <label class="label">Quand
        <input class="champ" id="ev-quand" type="datetime-local" value="${pourChamp(e.quand)}">
      </label>
      <label class="label">Où
        <input class="champ" id="ev-lieu" maxlength="160" value="${esc(e.lieu || "")}"
               placeholder="Ex : ICC Parakou, quartier Zongo">
      </label>
      <label class="coche"><input type="checkbox" id="ev-direct"${e.direct ? " checked" : ""}> Ce rendez-vous est diffusé en direct</label>
      <label class="label" id="ev-lien-bloc"${e.direct ? "" : " hidden"}>Lien du direct (YouTube ou Facebook)
        <input class="champ" id="ev-lien" value="${esc(e.lienDirect || "")}" placeholder="https://youtube.com/live/…">
      </label>
      <label class="label">Description
        <textarea class="champ" id="ev-desc" rows="4" maxlength="2000"
                  placeholder="Ce qui se passera, à qui c'est ouvert, ce qu'il faut apporter…">${esc(e.description || "")}</textarea>
      </label>
      <div class="depot-bapteme">
        <div id="ev-apercu">${e.image ? `<img src="${esc(e.image)}" alt="">` : ""}</div>
        <label class="btn btn--gris btn--petit">Affiche (facultatif)<input type="file" id="ev-image" accept="image/*" hidden></label>
        <span class="petit texte-doux" id="ev-info"></span>
      </div>`,
    actions: [
      { label: "Annuler" },
      {
        label: existant ? "Enregistrer" : "Créer l'événement",
        classe: "btn--primaire",
        onClick: async (fond, fermer) => {
          const titre = fond.querySelector("#ev-titre").value.trim();
          if (!titre) return toast("Donnez un titre à l'événement", "erreur");
          const brut = fond.querySelector("#ev-quand").value;
          if (!brut) return toast("Indiquez la date et l'heure", "erreur");
          const quand = new Date(brut).getTime();
          if (!quand) return toast("Date invalide", "erreur");

          const donnees = {
            titre,
            quand,
            lieu: fond.querySelector("#ev-lieu").value.trim(),
            description: fond.querySelector("#ev-desc").value.trim(),
            direct: fond.querySelector("#ev-direct").checked,
            lienDirect: fond.querySelector("#ev-lien").value.trim(),
            ...rattachement,
          };
          if (image !== null) donnees.image = image;
          fermer();
          try {
            if (existant) {
              await Store.evenements.modifier(existant.id, donnees);
              toast("Événement mis à jour");
              apres?.(existant.id);
            } else {
              const id = await Store.evenements.creer({
                ...donnees,
                image: image || "",
                auteurNom: ctx.moi.nom,
                auteurPhoto: ctx.moi.photo || "",
              });
              toast("Événement créé 🗓️");
              apres ? apres(id) : (location.hash = `#/evenement/${id}`);
            }
          } catch (err) {
            toast(err.message || "Enregistrement impossible", "erreur");
          }
        },
      },
    ],
  });

  // le champ du lien ne sert à rien tant que la case n'est pas cochée
  const coche = el.querySelector("#ev-direct");
  coche.addEventListener("change", () => {
    el.querySelector("#ev-lien-bloc").hidden = !coche.checked;
    if (coche.checked) el.querySelector("#ev-lien").focus();
  });

  let image = null;
  el.querySelector("#ev-image").addEventListener("change", async (ev) => {
    const f = ev.target.files?.[0];
    if (!f) return;
    el.querySelector("#ev-info").textContent = "Préparation de l'affiche…";
    try {
      image = await Store.upload(f, "image");
      el.querySelector("#ev-apercu").innerHTML = `<img src="${esc(image)}" alt="">`;
    } catch (err) {
      toast(err.message || "Image impossible à charger", "erreur");
    }
    el.querySelector("#ev-info").textContent = "";
  });
  el.querySelector("#ev-titre").focus();
}
